import { LogoutDirectiveModule } from 'directives/logout.directive';

export const OverflowMenuLogoutComponentModule = angular
    .module('app.components.pageHeader.overflowMenuLogout', [
        LogoutDirectiveModule
    ]).component('overflowMenuLogout', {
        template: `
            <md-menu-item>
                <md-button logout>{{"STORE.LOGOUT" | translate}}</md-button>
            </md-menu-item>
        `
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuLogout.js